/**
 * Словарь тонов краски — 9 дискретных цветовых категорий RAL classic.
 *
 * Источник истины: колонка `Тон` в
 * `<BASE_PATH>/Краски/Фасады краска Ралы фото Готов.csv`. Все 9 значений
 * скопированы verbatim из CSV — никаких переименований, без сортировки
 * по «логичному» порядку (значения в том порядке, в котором отсортировал
 * `awk -F';' '{print $4}' | sort -u` для воспроизводимости).
 *
 * Используется:
 *   - в Zod-схеме `PaintToneSchema` (`contracts/paint.ts`);
 *   - в UI-фильтрах Phase 3 (`PaintsCatalog` chip-группа);
 *   - в адаптере импорта `ral-classic.ts` для валидации tone из CSV.
 */
export const PAINT_TONES = Object.freeze([
  'Белые и черные тона',
  'Желтые тона',
  'Зеленые тона',
  'Коричневые тона',
  'Красные тона',
  'Оранжевые тона',
  'Серые тона',
  'Синие тона',
  'Фиолетовые тона',
] as const);
export type PaintTone = (typeof PAINT_TONES)[number];

export function getPaintTones(): readonly PaintTone[] {
  return PAINT_TONES;
}
